import { roundAwayFromZero } from "~/utils/round-away-from-zero";

import { type VariantChoiceWithMeta } from "./map-basket-choices-to-variants";

export function calculateVariantsGrossPrice(
  variantChoiceMap: Map<string, VariantChoiceWithMeta>
): number {
  let total = 0;

  for (const { choice, quantity } of variantChoiceMap.values()) {
    // Match server `calculateConfigTotal`: round each option's incl per-unit
    // price to whole minor units, then ×quantity and round the per-option total.
    if (choice.unitPriceInclVat) {
      total += roundAwayFromZero(
        roundAwayFromZero(choice.unitPriceInclVat) * quantity
      );
    }
  }

  return total;
}
